export enum ApplicationType {
  Supplier = 'supplier_application',
  Credit = 'loan_application',
  InHouseCredit = 'in-house-credit',
}
